import React from 'react'

function Loader() {
  return (
    <div>
    <div class="spinner"></div>
    </div>
  )
}

export default Loader